/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Template predefinito per il bootstrap di un ServizioMensa
 */
export enum ServizioMensaTemplate {

    MENSA_ESEMPIO = 'MENSA_ESEMPIO'
}

